module.exports = __webpack_public_path__ + "img/connected.faba73e9.png";